import { render, staticRenderFns } from "./OrganismReturnTo.vue?vue&type=template&id=1314c3d4"
import script from "./OrganismReturnTo.vue?vue&type=script&lang=js"
export * from "./OrganismReturnTo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports